import {combineReducers} from 'redux'
import {tabs} from '../tabs/TabsReducers';
import {order} from '../order/OrderReducers';
import {steps} from '../steps/StepsReducers';
import {result} from '../result/ResultReducers';
import {bridge} from "../bridge/BridgeReducers";
import {inline} from "../inline/InlineReducers";
import {updatePi} from "../update-pi/UpdatePiReducer";
import {subforms} from '../order/subforms/SubformsReducers';
import {modals} from "../common/modals/ModalsReducer";
import {reducer as forms} from 'redux-form';
import {
  APP_CHANGE_DEFAULT_MERCHANT_ID,
  APP_CONFIG_SET,
  APP_MODE_SET, APP_SETUP_CHANGE_BILLING_ADDRESS,
  APP_SETUP_CHANGE_CUSTOMER,
  APP_SETUP_CHANGE_PERSONA, APP_SETUP_CHANGE_SHIPPING_ADDRESS,
  APP_SETUP_CONFIGURE
} from './AppActions';
import {APP_MODE_QA, APP_STATUS_CONFIGURED, APP_STATUS_NOT_CONFIGURED, APP_STATUS_READY} from './AppConstants';


const initialEnvironemntState = {};

const initialConfigState = {
  environment: initialEnvironemntState,
  order: {}
};

const initialAppState = {
  mode: APP_MODE_QA,
  status: APP_STATUS_NOT_CONFIGURED,
  config: initialConfigState,
  defaultMerchantId: null
};

export function app(state = initialAppState, action) {
  switch (action.type) {
    case APP_CONFIG_SET:
      return {
        ...state,
        config: action.value,
        status: APP_STATUS_READY
      };
    case APP_SETUP_CONFIGURE:
      return {
        ...state,
        config: config(state.config, action),
        status: APP_STATUS_CONFIGURED
      };
    case APP_CHANGE_DEFAULT_MERCHANT_ID:
      return {
        ...state,
        defaultMerchantId: action.value
      };
    case APP_SETUP_CHANGE_CUSTOMER:
    case APP_SETUP_CHANGE_PERSONA:
    case APP_SETUP_CHANGE_SHIPPING_ADDRESS:
    case APP_SETUP_CHANGE_BILLING_ADDRESS:
      return {
        ...state,
        config: config(state.config, action)
      };
    case APP_MODE_SET:
      return {
        ...state,
        mode: action.value,
      };
    default:
      return state;
  }
};

export function config(state = initialConfigState, action) {
  switch (action.type) {
    case APP_SETUP_CONFIGURE:
      return {
        ...state,
        environment: action.value
      };
    case APP_SETUP_CHANGE_CUSTOMER:
    case APP_SETUP_CHANGE_PERSONA:
    case APP_SETUP_CHANGE_SHIPPING_ADDRESS:
    case APP_SETUP_CHANGE_BILLING_ADDRESS:
      return {
        ...state,
        environment: environment(state.environment, action)
      };
    default:
      return state;
  }
};

export function environment(state = initialEnvironemntState, action) {
  switch (action.type) {
    case APP_SETUP_CHANGE_CUSTOMER:
      return {
        ...state,
        customer: action.action
      };
    case APP_SETUP_CHANGE_PERSONA:
      return {
        ...state,
        persona: action.action
      };
    case APP_SETUP_CHANGE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress: action.action
      };
    case APP_SETUP_CHANGE_BILLING_ADDRESS:
      return {
        ...state,
        billingAddress: action.action
      };
    default:
      return state;
  }
};

export const getAppStatus = state => {
  return state.app.status;
};

export const getAppMode = state => {
  return state.app.mode;
};

const rootReducer = combineReducers({
  app, config, environment, tabs, order, subforms, steps, result, bridge, inline, modals, updatePi, form: forms
});

export default rootReducer



// WEBPACK FOOTER //
// ./src/app/AppReducers.js